import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import type { DiscountOverview } from '../dtos'
import type { Product } from '../enums'

const baseUrl = import.meta.env.VITE_BASE_URL
const apiUrl = import.meta.env.VITE_SUPERVIZOR_API
const url = `${baseUrl}/${apiUrl}`

export const useGetDiscountsOverview = (product: Product) => {
    return useQuery({
        queryKey: ['discountsOverview', product],
        queryFn: () => axios.get<DiscountOverview>(`${url}/GetDiscountsOverview`, { params: { product } })
    })
}
